import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: theme.spacing(1.5, 1.75),
  fontSize: theme.typography.pxToRem(15),
  textTransform: 'capitalize',
  '&.NMIpreventAnimation': {
    '&:hover': {
      backgroundColor: 'inherit !important',
    },
    '&:active': {
      backgroundColor: 'inherit !important',
    },
    '&:focus': {
      backgroundColor: 'inherit !important',
      outline: 'none !important',
    },
  },
  '&.NMIReadOnly': {
    pointerEvents: 'none',
  },

  '& .NMIIcon': {
    minWidth: theme.spacing(3),
    height: '100%',
    '& svg': {
      color: theme.palette.common.white,
      fontSize: theme.spacing(2),
    },
    '& .UDAvatar': {
      width: theme.spacing(2),
      height: theme.spacing(2),
      backgroundColor: theme.palette.common.fogWhite,
      fontSize: theme.spacing(1),

      '& .UDMFisrtLitter': {
        fontSize: theme.spacing(1.25),
        fontWeight: 700,
        position: 'relative',
        top: theme.spacing(0.175),
      },
    },
  },
  '& .NMILable': {
    lineHeight: theme.spacing(2.25),
    fontSize: theme.typography.pxToRem(15),
  },
  '&.NMIHasSubLable': {
    alignItems: 'flex-start',

    '& .NMISubLable': {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(0.75),
      lineHeight: theme.spacing(1.75),
    },
  },
}));

export default StyledMenuItem;
